import i18n from './I18n'
export default i18n
